import PropTypes from "prop-types";
import { Modal, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ErrorModal = ({ open, handleClose, title, message, url }) => {
    const { t } = useTranslation("settings");
    const history = useHistory();

    const handleRedirect = () => {
        if (url) {
            history.push(url);
        }
        handleClose();
    };

    return (
        <Modal
            title={
                <div className="flex items-center gap-2">
                    <ExclamationCircleOutlined className="text-red-500 text-xl" />
                    <span className="text-red-500 font-semibold text-lg">{t("integrations.errorModal.title")}</span>
                </div>
            }
            open={open}
            onCancel={handleClose}
            closable={true}
            maskClosable={false}
            keyboard={false}
            footer={null}
            centered
            width={500}
            className="error-modal">
            <div className="py-2 px-2">
                {/* Error Content */}
                <div className="mb-6 text-center">
                    <h3 className="text-lg font-semibold text-gray-800 mb-3 leading-tight">{title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{message}</p>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end gap-3">
                    <Button shape="round" size="small" onClick={handleClose}>
                        {t("cancel")}
                    </Button>

                    <Button shape="round" size="small" type="primary" danger onClick={handleRedirect}>
                        {t("integrations.errorModal.editInfo")}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

ErrorModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

export default ErrorModal;
